(() => {
  const layouts = {
    single: { label: 'Single Monitor Mount (included)', part: 'Single Monitor Mount (included)', addOns: ['none', 'laptop', 'side'] },
    stacked: { label: 'Upper-Lower Monitor Mount', part: 'Upper-Lower Monitor Mount', addOns: ['none', 'laptop', 'side'] },
    'side-by-side': { label: 'Side-By-Side Monitor Mount', part: 'Side-By-Side Monitor Mount', addOns: ['none'] },
    triple: { label: 'Triple Monitor Mount', part: 'Triple Monitor Mount', addOns: ['none'] }
  };
  const addOns = { none: { label: '', part: '' }, laptop: { label: ' + Laptop Mount', part: ' + Laptop Mount' }, side: { label: ' + Side Monitor', part: ' + Side Monitor Mount' } };
  const labelFor = (layout, addon) => layouts[layout].label + addOns[addon].label;
  function init(root) {
    if (root.dataset.awReady) return;
    root.dataset.awReady = 'true';
    let layout = 'single', addon = 'none', visible = 0, renderToken = 0;
    const visual = root.querySelector('[data-aw-visual]');
    const images = [...visual.querySelectorAll('img')];
    const links = root.querySelector('[data-aw-links]');
    const products = JSON.parse(root.querySelector('[data-aw-products]').textContent);
    const cartButton = root.querySelector('[data-aw-cart]');
    const status = root.querySelector('[data-aw-cart-status]');
    let adding = false;
    const stationForm = [...document.querySelectorAll('product-form form')].find(form => products.station.variants.some(v => String(v.id) === String(form.querySelector('[name="id"]')?.value)));
    function stationVariant() {
      const id = stationForm?.querySelector('[name="id"]')?.value;
      return products.station.variants.find(v => String(v.id) === String(id)) || products.station.variants.find(v => v.available);
    }
    function selectedItems() {
      const items = [{ key: 'station', product: products.station, variant: stationVariant() }];
      if (layout !== 'single') items.push({ key: layout, product: products[layout], variant: products[layout]?.variants.find(v => v.available) });
      if (addon !== 'none') items.push({ key: addon, product: products[addon], variant: products[addon]?.variants.find(v => v.available) });
      return items;
    }
    function updateCartState() {
      const available = selectedItems().every(item => item.variant?.available);
      cartButton.disabled = adding || !available;
      cartButton.textContent = adding ? 'Adding setup…' : available ? 'Add setup to cart' : 'Setup unavailable';
      const variant = stationVariant();
      root.querySelector('[data-aw-variant-note]').textContent = variant ? `Station: ${variant.title}. Change colors in the Station options above.` : 'Choose your Station colors above.';
    }
    document.addEventListener('variant:change', updateCartState);
    stationForm?.addEventListener('change', updateCartState);
    cartButton.addEventListener('click', async () => {
      if (adding || cartButton.disabled) return;
      const selection = selectedItems();
      if (!selection.every(item => item.variant?.available)) { updateCartState(); return; }
      adding = true;
      status.textContent = '';
      updateCartState();
      try {
        const items = selection.map(({ key, variant }) => ({
          id: variant.id,
          quantity: 1,
          ...(key === 'station' ? { properties: { 'Included mount': 'Single Monitor Mount (included)' } } : {})
        }));
        const cartRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This setup could not be added. Please try again.');
        window.location.assign(`${cartRoot}cart`);
      } catch (error) {
        status.textContent = error.message || 'This setup could not be added. Please try again.';
        adding = false;
        updateCartState();
      }
    });
    function render() {
      if (!layouts[layout].addOns.includes(addon)) addon = 'none';
      const key = addon === 'none' ? layout : `${layout}-${addon}`;
      const name = labelFor(layout, addon);
      const next = 1 - visible;
      const token = ++renderToken;
      const imageUrl = visual.getAttribute(`data-${key}`);
      if (!imageUrl) return;
      let shown = false;
      images[next].onload = () => {
        if (token !== renderToken || shown) return;
        shown = true;
        images[next].classList.add('is-visible');
        images[visible].classList.remove('is-visible');
        visible = next;
      };
      images[next].src = imageUrl;
      if (images[next].complete && images[next].naturalWidth) images[next].onload();
      visual.setAttribute('aria-label', `Signature Station with ${name.toLowerCase()}`);
      root.querySelector('[data-aw-name]').textContent = name;
      root.querySelectorAll('[data-aw-layout]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.awLayout === layout)));
      root.querySelectorAll('[data-aw-addon]').forEach(b => {
        const allowed = layouts[layout].addOns.includes(b.dataset.awAddon);
        b.disabled = !allowed;
        b.title = allowed ? '' : `${b.textContent.trim()} is not compatible with ${layouts[layout].label.toLowerCase()}.`;
        b.setAttribute('aria-pressed', String(b.dataset.awAddon === addon));
      });
      root.querySelector('[data-aw-hint]').textContent = layouts[layout].addOns.length === 1 ? 'This layout uses a dedicated mount and cannot be combined with another mount.' : '';
      const components = [['station', products.station.title]];
      components.push([layout === 'single' ? null : layout, layouts[layout].part]);
      if (addon !== 'none') components.push([addon, addOns[addon].part.replace(/^ \+ /, '')]);
      const nodes = [];
      components.forEach(([id, text], index) => {
        if (index) { const plus = document.createElement('span'); plus.textContent = '+'; plus.className = 'aw-config__plus'; nodes.push(plus); }
        const url = id && id !== 'station' ? links.getAttribute(`data-${id}-url`) : null;
        const item = document.createElement(url ? 'a' : 'span');
        if (url) item.href = url;
        item.textContent = text;
        if (!id) item.className = 'aw-config__included';
        nodes.push(item);
      });
      links.replaceChildren(...nodes);
      status.textContent = '';
      updateCartState();
    }
    root.addEventListener('click', e => {
      const b = e.target.closest('button[data-aw-layout], button[data-aw-addon]');
      if (!b || b.disabled || adding || !root.contains(b)) return;
      if (b.dataset.awLayout) layout = b.dataset.awLayout;
      else addon = b.dataset.awAddon;
      render();
    });
    render();
  }
  document.querySelectorAll('[data-aw-config]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-aw-config]').forEach(init));
})();
